<template>
    <div class="reset-psw-wrapper" v-loading="loading">
        <div class="reset-psw-label">{{ $t("password.resetTitle") }}</div>
        <div class="reset-psw-form">
            <ValidableInput
                :key="item.name"
                v-for="item in inputs"
                :type="item.type"
                v-model="item.value"
                :placeholder="item.placeholder"
                :errorTips="item.errorTips"
                :required="item.required"
                :label="item.label"
                :pattern="item.pattern"
                :class="{ [item.notEmptyCls]: !!item.value.value }"
                @input="inputHandler(item)"
            />
            <button class="reset-psw-confirm" @click="confirmHandler">{{ $t("zhiji.common.confirm") }}</button>
        </div>
    </div>
</template>

<script>
import ValidableInput from "./components/ValidableInput";
import { resetPassWord } from "./service.js";
import i18n from "@/i18n";

export default {
    name: "ResetPassword",
    components: {
        ValidableInput
    },
    data() {
        return {
            inputs: [
                {
                    type: "password",
                    label: "password.oldPsw.label",
                    required: true,
                    placeholder: "login.pasw.placeholder",
                    errorTips: "password.oldPsw.tips",
                    name: "oldPsw",
                    notEmptyCls: "reset-old-psw",
                    value: {
                        value: "",
                        isValided: null
                    }
                },
                {
                    type: "password",
                    label: "password.newPsw.label",
                    required: true,
                    placeholder: "login.pasw.placeholder",
                    errorTips: "password.newPsw.tips",
                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/,
                    name: "newPsw",
                    value: {
                        value: "",
                        isValided: null
                    }
                },
                {
                    type: "password",
                    label: "password.confrimPsw.label",
                    required: true,
                    placeholder: "login.pasw.placeholder",
                    errorTips: "password.confrimPsw.tips",
                    name: "newpswConfirm",
                    value: {
                        value: "",
                        isValided: null
                    }
                }
            ],
            loading: false
        };
    },
    methods: {
        inputHandler(item) {
            if (item.name == "newpswConfirm") {
                this.checkConfirm();
            }
        },
        confirmHandler() {
            this.checkAllInput();
            const canConfirm = this.inputs.every(item => {
                return item.value.isValided;
            });

            canConfirm && this.confirm();
        },
        checkAllInput() {
            this.inputs.forEach(item => {
                if (item.required && !item.value.value) {
                    item.value.isValided = false;
                }
            });
            this.checkConfirm();
        },
        checkConfirm() {
            const newPsw = this.inputs[1]; // 注意和data里面的inputs的name一致的项
            const newpswConfirm = this.inputs[2];

            if (newPsw.value.value != newpswConfirm.value.value) {
                return (newpswConfirm.value.isValided = false);
            }

            return (newpswConfirm.value.isValided = true);
        },
        async confirm() {
            const oldPsw = this.inputs[0].value.value;
            const newPsw = this.inputs[1].value.value;
            this.loading = true;

            const isSuccess = await resetPassWord(oldPsw, newPsw);
            if (isSuccess) {
                this.$message({
                    message: i18n.t("password.tips.reset.ok"),
                    type: "success"
                });
                this.clearInput();
            }

            this.loading = false;
        },
        clearInput() {
            this.inputs.forEach(item => {
                item.value.value = "";
                item.value.isValided = null;
            });
        }
    }
};
</script>

<style lang="less" scoped>
.reset-psw-wrapper {
    width: 100%;
    padding: 16px 24px;
    box-sizing: border-box;
    background: #f2f7fb;
    height: 100%;
}

.reset-psw-label {
    font-size: 14px;
    margin-bottom: 8px;
}

.reset-psw-form {
    background: #fff;
    padding: 32px 16px;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    .valid-input-tip {
        font-size: 12px;
    }
}

.reset-psw-confirm {
    display: inline-block;
    min-width: 96px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    border: 1px solid #2ec2ff;
    background: #2ec2ff;
    box-shadow: 0 0 6px 2px rgba(46, 98, 151, 0.2);
    border-radius: 20px;
    margin-left: 224px;
    padding: 0 24px;
    font-size: 12px;
    box-sizing: border-box;
    cursor: pointer;
    outline: none;
}

.reset-old-psw {
    /deep/ input {
        background-color: #e8f0fe;
    }
}
</style>
